export function stripMarkdownToPlainText(markdown: string): string {
  if (!markdown) {
    return ''
  }

  const stripped = markdown
    .replace(/```[\s\S]*?```/g, ' ')
    .replace(/`([^`]+)`/g, '$1')
    .replace(/!\[([^\]]*)\]\([^)]+\)/g, '$1')
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    .replace(/^\s{0,3}>\s?/gm, '')
    .replace(/^\s{0,3}([-*+])\s+/gm, '')
    .replace(/^\s{0,3}\d+\.\s+/gm, '')
    .replace(/\*{1,2}([^*]+)\*{1,2}/g, '$1')
    .replace(/_{1,2}([^_]+)_{1,2}/g, '$1')
    .replace(/~~([^~]+)~~/g, '$1')
    .replace(/^\s{0,3}#{1,6}\s+/gm, '')
    .replace(/\r/g, '')
    .replace(/\n{3,}/g, '\n\n')

  return stripped.trim()
}

export function normalizeMarkdownForRendering(markdown: string): string {
  if (!markdown) {
    return ''
  }

  // Normalize bold markers with accidental inner-edge spaces:
  // `** text **` -> `**text**`
  return markdown.replace(/\*\*([^*\n][^*\n]*?)\*\*/g, (_match, content: string) => {
    const normalizedContent = content.trim()
    return normalizedContent.length > 0 ? `**${normalizedContent}**` : content
  })
}
